import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import moment from 'moment';

const CreatedField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	const inputValue = customerForFullInfo?.insertedDate
		? `${moment(customerForFullInfo.insertedDate).format('MM/DD/YYYY h:mm:ss A')}      ${
				customerForFullInfo.insertedBy
		  }`
		: undefined;

	return <FullInfoField label="createdLabel" value={inputValue} />;
};

export default CreatedField;
